// SM-2 spaced repetition algorithm.
// Card SRS fields: srsInterval (days), srsEaseFactor, srsRepetitions, srsDueDate (ISO string).

const QUALITY = { again: 0, hard: 2, good: 4, easy: 5 };
const DEFAULT_EASE = 2.5;
const MIN_EASE = 1.3;

function todayMs() {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    return d.getTime();
}

function addDays(days) {
    return new Date(todayMs() + days * 86400000).toISOString();
}

export function applyRating(card, confidenceKey) {
    const q = QUALITY[confidenceKey] ?? 4;
    const interval  = card.srsInterval     ?? 0;
    const ease      = card.srsEaseFactor   ?? DEFAULT_EASE;
    const reps      = card.srsRepetitions  ?? 0;

    let newInterval, newReps, newEase;

    if (q < 3) {
        // Failed — reset
        newReps     = 0;
        newInterval = 1;
    } else {
        newReps = reps + 1;
        if (reps === 0)      newInterval = 1;
        else if (reps === 1) newInterval = 6;
        else {
            const base = Math.round(interval * ease);
            newInterval = confidenceKey === 'easy' ? Math.round(base * 1.3) : base;
        }
    }

    newEase = Math.max(MIN_EASE, ease + 0.1 - (5 - q) * (0.08 + (5 - q) * 0.02));

    return {
        ...card,
        srsInterval:    newInterval,
        srsEaseFactor:  Math.round(newEase * 100) / 100,
        srsRepetitions: newReps,
        srsDueDate:     addDays(newInterval),
    };
}

export function isDue(card) {
    if (!card.srsDueDate) return true; // never rated = always due
    return new Date(card.srsDueDate).getTime() <= todayMs() + 86400000; // due today or earlier
}

export function dueCount(cards) {
    return cards.filter(isDue).length;
}

export function nextReviewLabel(card) {
    if (!card.srsDueDate) return 'due now';
    const diff = Math.round((new Date(card.srsDueDate).getTime() - todayMs()) / 86400000);
    if (diff <= 0) return 'due now';
    if (diff === 1) return 'in 1 day';
    if (diff < 30)  return `in ${diff} days`;
    const weeks = Math.round(diff / 7);
    if (weeks < 8)  return `in ${weeks} week${weeks !== 1 ? 's' : ''}`;
    const months = Math.round(diff / 30);
    return `in ${months} month${months !== 1 ? 's' : ''}`;
}
